import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import type { Role } from './useRole'

const useCanEditRole = (role?: Role) => {
  const { loading: loadingCanEditJob } = useAsyncData(
    () =>
      !role
        ? Promise.resolve()
        : policyAuthorizations.authorizePolicies('job_catalog.edit_job', [role]),
    [!!role]
  )

  return [policyAuthorizations.for('job_catalog.edit_job', role), loadingCanEditJob]
}

export default useCanEditRole
